import { styled as o } from "styled-components";
import { Icon as r } from "../../../components/Icon/index.js";
import { BodyHeavy as a, SmallLight as e } from "../../../styles/typography/index.js";
import { MediaQuery as t } from "../../../styles/variables.js";
import { Theme as i } from "../../../styles/themes/index.js";
const m = o.header`
  width: 100%;
  display: block;
  padding: 18px 12px 0 12px;
  border-bottom-left-radius: 6px;
  border-bottom-right-radius: 6px;

  @media ${t.SCREEN_MD_UP} {
    padding: 24px 12px 24px 24px;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
`, s = o(r)`
  font-size: 16px;
  cursor: pointer;
  color: rgb(${i.colors.Alpha});

  @media ${t.SCREEN_MD_UP} {
    display: none;
  }
`, g = o.div`
  display: flex;
  align-items: center;
  margin-bottom: 18px;
  h2 {
    ${a}
    margin: 0 auto;
    color: rgb(${i.colors.Alpha});
  }

  @media ${t.SCREEN_MD_UP} {
    margin-bottom: 0;
  }
`, x = o(r)`
  display: none;
  font-size: 24px;
  @media ${t.SCREEN_MD_UP} {
    display: block;
    margin-left: 8px;
    color: rgb(${i.colors.Brand});
  }
`, f = o.button`
  ${e}
  background: transparent;
  color: rgb(${i.colors.Brand});
  font-size: 12px;
  line-height: 16px;
  text-align: right;
  width: 100%;
  margin: 12px 0;

  @media ${t.SCREEN_MD_UP} {
    width: auto;
    margin: 0;
  }
`;
export {
  s as NotificationBarBackButton,
  x as NotificationBarBellIcon,
  m as NotificationBarHeaderContainer,
  f as NotificationBarReadAllButton,
  g as NotificationBarTitle
};
